export default {
  hero: {
    title: 'Your campaign is live',
    subtitle:
      'AhaCreator is now matching influencers from the full pool and will start sending invitations shortly.',
  },
  buttons: {
    backToHome: 'Back to Home',
  },
  whatNext: {
    title: 'What happens next',
  },
  happeningNow: 'Happening now',
  timeline: {
    step1: {
      title: 'Campaign created',
      desc: 'Strategy confirmed and budget set',
    },
    step2: {
      title: 'Campaign under review',
      desc: 'Full pool matching based on your strategy. Your 3 saved influencers will be invited first.',
    },
    step3: {
      title: 'AhaCreator is matching influencers',
      desc: 'Full pool matching based on your strategy. Your 3 saved influencers will be invited first.',
    },
    step4: {
      title: 'Influencers receive invitations',
      desc: 'Matched influencers review your brief and submit proposals with pricing.',
    },
    step5: {
      title: 'Review and approve',
      desc: 'Review influencer proposals, negotiate terms, and approve collaborations.',
    },
    step6: {
      title: 'Content delivery',
      desc: 'Influencers produce and publish content. Payment processed after your approval.',
    },
  },
  whileWait: {
    title: 'While you wait, you can set up content requirements',
    desc: 'Configure influencer briefs, reference videos, posting guidelines, and deadlines so influencers know exactly what to deliver.',
  },
  cards: {
    goToDetails: {
      label: 'Go to details',
      title: 'View campaign details',
    },
    newCampaign: {
      label: 'New campaign',
      title: 'Create another',
    },
  },
};
